<template>
  <div></div>
  <!-- <div class="downLoad">
    <div class="logo">
      <img width="30%" :src="require('../../assets/images/download/logo.png')" />
    </div>
    <div class="btn">
      <a href="javascript:;" @click="downApp('ios')">
        <img width="51%" :src="require('../../assets/images/download/iosbtn.png')" />
      </a>
      <a href="javascript:;" @click="downApp('android')">
        <img width="51%" :src="require('../../assets/images/download/androidbtn.png')" />
      </a>
    </div>
    <div class="dialog" v-if="downData.visible" @click="closeDialog()">
      <i></i>
      <p v-if="downData.isIssue">版本暂未发布，敬请期待！</p>
      <p v-else>此设备不支持下载</p>
    </div>
    <div class="share" v-if="downData.isWechat">
       <div class="shareImg"><img :src='require("../../assets/images/share.png")'></div>
    </div>
  </div> -->
</template>

<script>
/* eslint-disable */
// import Cookie from '@/common/utils/Cookie.js'
import { queryDownload } from '@/data/api/download'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
import Os from '@/common/utils/Os'
export default {
  name: 'DownloadPage',
  data () {
    return {
      downData: {
        visible: false,
        isIssue: true,
        isWechat: true,
        data: {
          androidDownloadUrl: '',
          iosDownloadUrl: ''
        }
      },
      channel: '',
      callAppUrl: ''
    }
  },
  mounted () {
    window.location.assign("https://a.app.qq.com/o/simple.jsp?pkgname=com.saicmobility.user")
    this.isWechat()
    this.getList()
    // 获取channel信息
    // this.channel = this.$route.query.channel ? this.$route.query.channel : Cookie.get('X-Saic-Channel')
    // 打点上报公共方法
    this.callAppUrl = this.$route.query.targetScheme ? decodeURIComponent(this.$route.query.targetScheme) : 'saicpassenger://home'
    //this.openApp()
    this.$nextTick(_ => {
      UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
    })
  },
  methods: {
    // 判断是否实在微信浏览器中打开
    isWechat: function () {
      let ua = navigator.userAgent.toLowerCase()
      let isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        this.downData.isWechat = true
      } else {
        this.downData.isWechat = false
      }
    },
    getList () {
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      // queryDownload({channelCode: this.channel}).then(response => {
      //   let data = response
      //   this.downData.data = {
      //     androidDownloadUrl: data.androidDownloadUrl,
      //     iosDownloadUrl: data.iosDownloadUrl
      //   }
      // }).catch(_ => {}).finally(_ => {
      //   this.$mint.Indicator.close()
      // })
    },
    // downApp (type) {
    //   if (type === 'ios') {
    //     // 打点上报公共方法
    //     UpdateLogData({path: this.$route.path, action: 'iOSDownload', hasRedPacket: false})
    //     if (Os.ios) {
    //       if (this.downData.data.iosDownloadUrl) {
    //         window.location.href = this.downData.data.iosDownloadUrl
    //       } else {
    //         this.downData.visible = true
    //         this.downData.isIssue = true
    //       setTimeout(()=>{
    //         this.downData.visible = false
    //       },2000)  
    //       }
    //     } else {
    //       this.downData.visible = true
    //       this.downData.isIssue = false
    //       setTimeout(()=>{
    //         this.downData.visible = false
    //       },2000)       
    //     }
    //   } else {
    //     // 打点上报公共方法
    //     UpdateLogData({path: this.$route.path, action: 'androidDownload', hasRedPacket: false})
    //     if (Os.android) {
    //       if (this.downData.data.androidDownloadUrl) {
    //         window.location.href = this.downData.data.androidDownloadUrl
    //       } else {
    //         this.downData.visible = true
    //         this.downData.isIssue = true
    //         setTimeout(()=>{
    //           this.downData.visible = false
    //         },2000)                       
    //       }
    //     } else {
    //       this.downData.visible = true
    //       this.downData.isIssue = false
    //       setTimeout(()=>{
    //         this.downData.visible = false
    //       },2000)          
    //     }
    //   }
    // },
    closeDialog () {
      this.downData.visible = false
    },
    // openApp () {
    //   UpdateLogData({path: this.$route.path, action: 'gotoApp'})
    //   var ifr = document.createElement('iframe')
    //   if ((navigator.userAgent.toLowerCase().indexOf('android'))) {
    //     window.location.href = this.callAppUrl
    //   }
    //   ifr.src = this.callAppUrl
    //   ifr.style.display = 'none'
    //   document.body.appendChild(ifr)
    //   document.body.removeChild(ifr)
    // }
  }
}
</script>

<style scoped lang="stylus">
.downLoad{
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: url(../../assets/images/download/downloadbg.jpg) no-repeat 0 bottom #00b9b4;
  background-size: cover;
}
.logo{
  padding: 18% 0;
  img{
    display: block;
    margin: 0 auto;
  }
}
.btn{
  img{
    display: block;
    margin: 0 auto;
    &:first-child{
      margin-bottom: 15px;
    }
  }
}
.dialog{
  width: 160px;
  height: 95px;
  border-radius: 5px;
  background: rgba(0,0,0,0.8);
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -48px 0 0 -80px;
  i{
    display: block;
    width: 32px;
    height: 32px;
    margin: 15px auto;
    background: url(../../assets/images/common/warn.png) no-repeat;
    background-size: 100%;
  }
  p{
    color: #fff;
    font-size: 0.75rem;
    text-align: center;
  }
}
.share{
   width:100%;
    height:100%;
    position :fixed;
    top:0;
    background :rgba(0,0,0,0.8);
    z-index:100
    img{
      width:100%
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DownLoad/index.vue